/**
 * Formats a number with K (thousands), M (millions), etc. suffix
 * Example: 176100 -> 176.1K
 */
export const formatNumberWithSuffix = (num: number): string => {
  if (num === 0) return "0";
  
  const abbreviations = [
    { value: 1e9, symbol: "B" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "K" }
  ];
  
  const item = abbreviations.find(item => num >= item.value);
  
  if (!item) return num.toString();
  
  const formatted = (num / item.value).toFixed(1).replace(/\.0$/, "");
  return `${formatted}${item.symbol}`;
};
